export const enum quizTestIds {
  QUESTIONS_PAGE = "quiz-questions-page",
  PROGRESS_BAR = "quiz-progress-bar",
  QUESTION_HEADING = "quiz-question-heading",
  SCHOOL_CARD = "quiz-school-card",
  SCHOOL_CARD_IMAGE = "quiz-school-card-image",
  POSITION_LABEL = "quiz-position-label",
  MOVE_UP_BUTTON = "quiz-move-up-button",
  MOVE_DOWN_BUTTON = "quiz-move-down-button",
  NEXT_BUTTON = "quiz-next-button",
  BACK_BUTTON = "quiz-back-button",
}

export enum quizDescriptionDataTestIds {
  QUIZ_DESCRIPTION_TITLE = "quiz-description-title",
  QUIZ_DESCRIPTION_CARD = "quiz-description-card",
  QUIZ_DESCRIPTION_CARD_CONTENT = "quiz-description-card-content",
  QUIZ_DESCRIPTION_CARD_TITLE = "quiz-description-card-title",
  QUIZ_DESCRIPTION_HEADER_IMAGE = "quiz-description-header-image",
  QUIZ_DESCRIPTION_START_QUIZ_BUTTON = "quiz-description-start-quiz-button",
  QUIZ_DESCRIPTION_HOW_IT_WORKS_SECTION = "quiz-description-how-it-works-section",
  QUIZ_DESCRIPTION_YOUR_TASK_SECTION = "quiz-description-your-task-section",
  QUIZ_DESCRIPTION_MATCHING_REASSURANCE_MESSAGE = "quiz-description-matching-reassurance-message",
  QUIZ_DESCRIPTION_SEASON_NOTICE = "quiz-description-season-notice",
}

export enum quizResultsPageDataTestIds {
  QUIZ_RESULTS_PAGE_CELEBRATION_EMOJI = "quiz-results-page-celebration-emoji",
  QUIZ_RESULTS_PAGE_TITLE = "quiz-results-page-title",
  QUIZ_RESULTS_PAGE_DESCRIPTION = "quiz-results-page-description",
  QUIZ_RESULTS_PAGE_BROWSE_JOBS_BUTTON = "quiz-results-page-browse-jobs-button",
  QUIZ_RESULTS_PAGE_NEXT_STEPS_CARD = "quiz-results-page-next-steps-card",
  QUIZ_RESULTS_PAGE_NEXT_STEPS_PREFERENCES_LINK = "quiz-results-page-next-steps-preferences-link",
  QUIZ_RESULTS_PAGE_EDIT_PREFERENCES_BUTTON = "quiz-results-page-edit-preferences-button",
}
